import Vue from 'vue'
import http from '../libs/http'
// import '../mock' // mock 数据模拟

Vue.prototype.$http = http
